// Note: Do not use this inside JS files since this is a constant enum
export var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["PUT"] = "PUT";
    Method["POST"] = "POST";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
export var DC;
(function (DC) {
    DC[DC["CH"] = 1] = "CH";
    DC[DC["HYD"] = 2] = "HYD";
})(DC || (DC = {}));
export var SupportedHostname;
(function (SupportedHostname) {
    SupportedHostname["WWW"] = "www.flipkart.com";
    SupportedHostname["ROME_NET"] = "rome.api.flipkart.net";
    SupportedHostname["ROME_COM"] = "rome.api.flipkart.com";
})(SupportedHostname || (SupportedHostname = {}));
